// validation/section8.js
import errorTrackerV2 from "./Utils/ErrorTrackerV2";

export function validateSection8(data = {}) {
  const f = data || {};
  const errors = {};

  const isEmptyObject =
    data &&
    typeof data === "object" &&
    !Array.isArray(data) &&
    Object.keys(data).length === 0;

  // If data is null, all required fields are missing
  if (data === null || data === undefined || isEmptyObject) {
    errors["dataNotFound"] =
      "No data found for this section. Please open and save it first.";
    errorTrackerV2.setSectionErrors("section8", errors);
    return errors;
  }
  const req = (cond, key) => {
    if (cond) errors[key] = "This field is required.";
  };

  const anyYes = [
    "expenditureExceedsIncome",
    "liabilitiesExceedAssets",
    "outstandingLiabilities",
    "propertyRepossessed",
    "otherProperty",
    "taxLiabilities",
    "rentalIncome",
    "otherIncome",
    "residentialMortgage",
    "outstandindLoansOrCreditCards",
    "BTLMortage",
    "debtManagementPlan",
    "outstandingFinancialServicesDebt",
  ].some((k) => f[k] === true);

  req(f.expenditureExceedsIncome == null, "expenditureExceedsIncome");
  req(f.liabilitiesExceedAssets == null, "liabilitiesExceedAssets");
  req(f.outstandingLiabilities == null, "outstandingLiabilities");
  req(f.propertyRepossessed == null, "propertyRepossessed");
  req(f.otherProperty == null, "otherProperty");
  req(f.taxLiabilities == null, "taxLiabilities");

  req(
    f.currentMonthlyIncome === "" || f.currentMonthlyIncome == null,
    "currentMonthlyIncome",
  );

  req(
    f.partnerMonthlyIncome === "" || f.partnerMonthlyIncome == null,
    "partnerMonthlyIncome",
  );

  req(f.rentalIncome == null, "rentalIncome");
  if (f.rentalIncome === true) {
    req(
      f.rentalIncomeAmount === "" || f.rentalIncomeAmount == null,
      "rentalIncomeAmount",
    );

    req(f.BTLMortage == null, "BTLMortage");
    if (f.BTLMortage === true) {
      (f.BTLMortageDetails || []).forEach((entry, i) => {
        req(!entry?.lender?.trim(), `BTLMortageDetails_${i}_lender`);
        req(
          entry?.monthlyAmount === "" || entry?.monthlyAmount == null,
          `BTLMortageDetails_${i}_monthlyAmount`,
        );
        req(
          entry?.outstandingAmount === "" || entry?.outstandingAmount == null,
          `BTLMortageDetails_${i}_outstandingAmount`,
        );
      });
    }
  }

  req(f.otherIncome == null, "otherIncome");
  if (f.otherIncome === true) {
    req(!f.otherIncomeSource?.trim(), "otherIncomeSource");
    req(
      f.otherIncomeAmount === "" || f.otherIncomeAmount == null,
      "otherIncomeAmount",
    );
  }

  req(f.residentialMortgage == null, "residentialMortgage");
  if (f.residentialMortgage === true) {
    req(!f.residentialMortgageLender?.trim(), "residentialMortgageLender");
    req(
      f.residentailMortgageAmount === "" || f.residentailMortgageAmount == null,
      "residentailMortgageAmount",
    );
    req(
      f.residentialHouseValue === "" || f.residentialHouseValue == null,
      "residentialHouseValue",
    );
    req(
      f.residentialOutstandingAmount === "" ||
        f.residentialOutstandingAmount == null,
      "residentialOutstandingAmount",
    );
  }

  req(f.outstandindLoansOrCreditCards == null, "outstandindLoansOrCreditCards");
  if (f.outstandindLoansOrCreditCards === true) {
    (f.outstandingLoandsOrCreditCardDetails || []).forEach((entry, i) => {
      req(!entry?.type?.trim(), `loanOrCreditCard_${i}_type`);
      req(!entry?.lender?.trim(), `loanOrCreditCard_${i}_lender`);
      req(
        entry?.monthlyAmount === "" || entry?.monthlyAmount == null,
        `loanOrCreditCard_${i}_monthlyAmount`,
      );
      req(
        entry?.outstandingAmount === "" || entry?.outstandingAmount == null,
        `loanOrCreditCard_${i}_outstandingAmount`,
      );
    });
  }

  req(
    f.householdExpenditurePerMonth === "" ||
      f.householdExpenditurePerMonth == null,
    "householdExpenditurePerMonth",
  );

  req(f.debtManagementPlan == null, "debtManagementPlan");
  if (f.debtManagementPlan === true) {
    (f.debtManagementPlanDetails || []).forEach((entry, i) => {
      req(
        !entry?.practitionerName?.trim(),
        `debtManagementPlanDetails_${i}_practitionerName`,
      );
      req(
        entry?.monthlyAmount === "" || entry?.monthlyAmount == null,
        `debtManagementPlanDetails_${i}_monthlyAmount`,
      );
      req(
        entry?.outstandingAmount === "" || entry?.outstandingAmount == null,
        `debtManagementPlanDetails_${i}_outstandingAmount`,
      );
    });
  }

  req(
    f.outstandingFinancialServicesDebt == null,
    "outstandingFinancialServicesDebt",
  );
  if (f.outstandingFinancialServicesDebt === true) {
    (f.outstandingFinancialServicesDebtDetails || []).forEach((entry, i) => {
      req(
        !entry?.to?.trim(),
        `outstandingFinancialServicesDebtDetails_${i}_to`,
      );
      req(
        entry?.amount === "" || entry?.amount == null,
        `outstandingFinancialServicesDebtDetails_${i}_amount`,
      );
    });
  }

  if (anyYes && !f.additionalInformation?.trim()) {
    errors.additionalInformation = "This field is required.";
  }

  errorTrackerV2.setSectionErrors("section8", errors);
  return errors;
}
